import { useState } from 'react';
import { api } from '../api';
import { useT } from '../i18n';

type Props = {
  runId: string | null;
  disabled?: boolean;
};

/**
 * Opens Telegram's native share sheet with a link to the run's share page.
 * Only useful when `runId` is the server-confirmed id (after submit succeeded).
 */
export function ShareButton({ runId, disabled }: Props) {
  const { t } = useT();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleShare() {
    if (!runId || busy) return;
    setBusy(true);
    setError(null);
    try {
      const card = await api.shareCard(runId);
      const shareSheetUrl =
        `https://t.me/share/url?url=${encodeURIComponent(card.shareUrl)}` +
        `&text=${encodeURIComponent(t('share.message'))}`;
      if (typeof window !== 'undefined') {
        window.open(shareSheetUrl, '_blank', 'noopener');
      }
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className="ghost"
      onClick={handleShare}
      disabled={disabled || busy || !runId}
      style={{
        padding: '8px 16px',
        fontSize: 12,
        letterSpacing: '0.06em',
      }}
      title={error ?? undefined}
    >
      {busy ? t('share.busy') : t('share.button')}
    </button>
  );
}
